
<div class="secondary-navbar" role="region">
  <row>
    <div class="left-panel">
      <slot name="left"></slot>
    </div>

    <div class="right-panel">
      <slot name="right"></slot>
    </div>
  </row>
</div>
